import React from 'react';
const OwnerProfile = props => {
  return <></>;
};
export default OwnerProfile;
